import * as Wizard from '#~/agent/components/wizard/index.js';
import { Paths } from '#~/routes/index.js';
import { ComputerIcon } from '../../computer-icon.js';
import { Anchor, Button } from '@studio/design-system/button';
import { getCurrentVendor, Vendor, vendorName } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHasSeenAgentSetup } from '#~/room/hook_last_id.js';
import { useEffect } from 'react';

/** `<Link>` component. */
export const Link = (): ReactElement => {
  const navigate = useNavigate();
  const [, setHasSeenAgentSetup] = useHasSeenAgentSetup();

  // Mark setup as seen when user reaches this page
  useEffect(() => {
    setHasSeenAgentSetup(true);
  }, [setHasSeenAgentSetup]);

  return (
    <Wizard.Root currentStep={4} totalSteps={4}>
      <div className='flex flex-grow flex-col items-center justify-center gap-[30px]'>
        <ComputerIcon className='text-primary' />
        <div>
          <Wizard.Verbiage.Title>Link {vendorName()} Bridge</Wizard.Verbiage.Title>
          <Wizard.Verbiage.Message>
            After downloading {vendorName()}, complete the installation process. After installing,
            open your Studio and search for available Bridges by selecting the Bridge icon. For step
            by step instructions, visit the help center below.
          </Wizard.Verbiage.Message>
        </div>
      </div>
      <Wizard.ButtonBox>
        <a
          href={
            getCurrentVendor() === Vendor.PTZOPTICS
              ? 'https://hivehelp.ptzoptics.com/en/articles/9707980-linking-a-bridge'
              : 'https://intercom.help/irisai/en/articles/9707980-linking-a-bridge'
          }
          className='no-underline'
        >
          <Button size='xl'>Go To Help Center</Button>
        </a>
        <Anchor
          className='text-primary'
          onClick={(): void => {
            navigate(`/${Paths.agent.setup.select}`);
          }}
        >
          Bridge not installed? Go back to download.
        </Anchor>
      </Wizard.ButtonBox>
    </Wizard.Root>
  );
};
